import { render, staticRenderFns } from "./Cropper.vue?vue&type=template&id=c0ca70fa&scoped=true"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"
import style0 from "./Cropper.vue?vue&type=style&index=0&id=c0ca70fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ca70fa",
  null
  
)

export default component.exports